import axios from "axios";
import api from "@/apiConfig/api";
import { encryptText } from "@/utils/cryptFunc";
import { resetBranchIdCache } from "@/composables/useBranchId";
import {
  storageGet,
  storageSet,
  storageRemoveMany,
  STORAGE_KEYS,
  LOGOUT_KEYS,
} from "@/services/storage.service";

export default {
  namespaced: true,
  state() {
    return {
      isAuthenticated: false,
      _authChecked: false,
      branch: storageGet(STORAGE_KEYS.BRANCH_ID),
      role: "",
    };
  },
  mutations: {
    setAuthenticated(state, value) {
      state.isAuthenticated = value;
    },
    setAuthChecked(state) {
      state._authChecked = true;
    },
    setRole(state, role) {
      state.role = role;
    },
    logout(state) {
      resetBranchIdCache();
      state.isAuthenticated = false;
      storageRemoveMany(LOGOUT_KEYS);
    },
    CHANGEBRANCH(state, payload) {
      state.branch = payload;
    },
  },
  actions: {
    async login({ commit }, payload) {
      await api.post("/auth/signin", payload).then((res) => {
        const {
          is_teacher,
          department,
          role,
          is_branch_admin,
          is_developer,
          head_access,
          first_name,
          last_name,
          id,
          phone,
        } = res.data.user;
        storageSet(STORAGE_KEYS.FIRSTNAME, first_name);
        storageSet(STORAGE_KEYS.LASTNAME, last_name);
        storageSet(STORAGE_KEYS.PHONE, phone || payload?.user?.phone || "");
        if (is_developer) {
          storageSet(STORAGE_KEYS.IS_DEVELOPER, true);
        }
        if (head_access) {
          storageSet(STORAGE_KEYS.HEAD_ACCESS, "true");
        }
        // Backend sets HttpOnly cookies automatically
        commit("setAuthenticated", true);
        commit("setRole", role);

        // Route user to the correct dashboard based on role
        const loggedIn = true;
        if (
          loggedIn &&
          !is_teacher &&
          department === 5 &&
          role === 0
        ) {
          window.location.pathname = "/academy-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("academy"));
          storageSet(STORAGE_KEYS.IS_MANAGER, "academy");
        } else if (
          loggedIn &&
          department === 1 &&
          role === 8
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("hunter"));
          window.location.pathname = "/hunter-dashboard";
        } else if (
          loggedIn &&
          !is_teacher &&
          department === 1
        ) {
          window.location.pathname = "/call-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("call"));
        } else if (
          loggedIn &&
          !is_teacher &&
          department === 4 &&
          role === 4
        ) {
          window.location.pathname = "/audit-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("audit"));
        } else if (loggedIn && is_teacher) {
          window.location.pathname = "/teacher-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("teacher"));
          storageSet(STORAGE_KEYS.USER_ID, id);
        } else if (
          loggedIn &&
          !is_teacher &&
          department === 5 &&
          role === 2
        ) {
          window.location.pathname = "/instructor-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("instructor"));
        } else if (
          loggedIn &&
          !is_teacher &&
          is_branch_admin
        ) {
          window.location.pathname = "/admin-dashboard";
          storageSet(STORAGE_KEYS.ROLE, encryptText("admin"));
          if (role === 0) {
            storageSet(STORAGE_KEYS.IS_SUPER_ADMIN, encryptText("superadmin"));
          }
          if (department === 0 && role === 3) {
            storageSet(STORAGE_KEYS.SUPER_USER, true);
          }
          if (role === 14) {
            storageSet(STORAGE_KEYS.IS_IT_SUPPORT, true);
          }
        } else if (
          loggedIn &&
          department === 0 &&
          role === 3
        ) {
          storageSet(STORAGE_KEYS.SUPER_USER, true);
        } else if (
          loggedIn &&
          department === 5 &&
          role === 5
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("examiner"));
          window.location.pathname = "/examiner-dashboard";
        } else if (
          loggedIn &&
          department === 6 &&
          role === 0
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("finance"));
          window.location.pathname = "/finance-dashboard";
        } else if (loggedIn && role === 16) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("kurator"));
          localStorage.setItem("is_kurator_manager", "true");
          window.location.pathname = "/kurator-dashboard";
        } else if (loggedIn && role === 6) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("kurator"));
          window.location.pathname = "/kurator-dashboard";
        } else if (loggedIn && department === 3) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("marketing"));
          window.location.pathname = "/marketing-dashboard";
        } else if (
          loggedIn &&
          department === 6 &&
          role === 7
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("axo"));
          window.location.pathname = "/axo-dashboard";
        } else if (
          loggedIn &&
          department === 5 &&
          role === 9
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("tutor"));
          window.location.pathname = "/tutor-dashboard";
          storageSet(STORAGE_KEYS.USER_ID, id);
        } else if (
          loggedIn &&
          department === 4 &&
          role === 12
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("moderator"));
          window.location.pathname = "/moderator-dashboard";
        } else if (
          loggedIn &&
          department === 5 &&
          role === 14
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("admin"));
          storageSet(STORAGE_KEYS.IS_IT_SUPPORT, true);
          window.location.pathname = "/admin-dashboard";
        } else if (
          loggedIn &&
          department === 5 &&
          role === 15
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("metodist"));
          window.location.pathname = "/metodist-dashboard";
        } else if (
          loggedIn &&
          department === 5 &&
          role === 11
        ) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("branchacademy"));
          window.location.pathname = "/branchacademy-dashboard";
        } else if (loggedIn && role === 13) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("bi"));
          window.location.pathname = "/bi-dashboard";
        } else if (role === 0 && department === 2) {
          storageSet(STORAGE_KEYS.ROLE, encryptText("hr"));
          window.location.pathname = "/hr-dashboard";
        }
      });
    },
    changeBranchAction({ commit }, payload) {
      commit("CHANGEBRANCH", payload);
    },
    async checkAuth({ commit }) {
      try {
        // Use raw axios to avoid response interceptor triggering refresh/logout loop
        await axios.get(`${api.defaults.baseURL}/auth/check?audience=admin`, {
          withCredentials: true,
        });
        commit("setAuthenticated", true);
      } catch {
        commit("setAuthenticated", false);
      }
      commit("setAuthChecked");
    },
    async logoutAction({ commit }) {
      try {
        await api.post("/auth/signout?audience=admin");
      } catch {
        // ignore errors on signout
      }
      commit("logout");
    },

    reloadWindow() {
      window.location.reload();
    },
  },
  getters: {
    isAuth(state) {
      return state.isAuthenticated;
    },
  },
};
